module.exports = "/images/vendor/flag-icon-css/flags/4x3/at.svg?e2634e96c9ad4694d5133cc83e2c6564";